import PropTypes from "prop-types";
import BaseComponent from "../../../../lib/components/BaseComponent";

import MuiMenu from "@mui/material/Menu";

class Menu extends BaseComponent {

  render() {
    return <MuiMenu {...this.props}/>;
  }

}

Menu.propTypes = {
  open: PropTypes.bool.isRequired, anchorEl: PropTypes.any, onClose: PropTypes.func
}
export default Menu;
